/**
 * Copyright (C) 2021 - 2026 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PopupDialogModule } from '../../components/popup-dialog/popup-dialog.module';
import { MaterialModule } from '../../shared-modules/material.module';
import { ErrorModalComponent } from './error-modal.component';

@NgModule({
	imports: [CommonModule, TranslateModule, MaterialModule, PopupDialogModule],
	declarations: [ErrorModalComponent],
})
export class ErrorModalModule {}
